<script setup lang="ts">
import {ref, onMounted } from 'vue'
import { RouterView, useRouter } from 'vue-router'

import Avatar from 'primevue/avatar';
import Button from 'primevue/button';
import ConfirmDialog from 'primevue/confirmdialog';
import Dialog from 'primevue/dialog';
import Drawer from 'primevue/drawer';

import FooterLinks from '@/components/FooterLinks.vue';
import NotificationsButton from '@/components/NotificationsButton.vue';
import SideMenu from '@/components/SideMenu.vue';
import Toast from 'primevue/toast';

import { userStore } from '@/stores/user'
import logoUrl from '@/assets/1.png';
import brandLogoUrl from '@/assets/logo.svg';

const user = userStore();

const visibleDrawer = ref(false);
const showAccountDialog = ref(false);


onMounted(async () => {
  if (user.loggedIn === false) {
    await user.refreshUser();
  }
})

const router = useRouter()
router.beforeEach(async (to, from) => {
  // Hide menu on route change
  visibleDrawer.value = false
})

async function signOut() {
  showAccountDialog.value = false;
  await user.logOut();
  router.push('/');
}

</script>

<template>

  <div class="relative flex min-h-screen w-full">

    <div v-if="user.loggedIn">
      <div class="fixed h-14 w-full bg-white top-0 left-0 z-20 flex items-center justify-between px-3 gap-6 border-b border-slate-200">
        <div class="flex items-center gap-6">
          <Button icon="pi pi-bars" class="md:hidden border-none text-slate-700 bg-white" @click="visibleDrawer = true" />
          <a href="https://the-odds-api.com" target="_blank" rel="noopener noreferrer" class="flex items-center">
            <img
                :src="brandLogoUrl"
                alt="The Odds API"
                style="height: 36px;"
            />
          </a>
        </div>

        <div class="flex items-center gap-3">
          <NotificationsButton />

          <Avatar
            icon="pi pi-user"
            shape="circle"
            class="cursor-pointer bg-white text-slate-700 border border-slate-700"
            @click="showAccountDialog = true"
          />
        </div>
      </div>

      <Drawer v-model:visible="visibleDrawer" :showCloseIcon="true" header="Menu" position="full" class="p-0 sm:w-100 md:hidden bg-slate-200">
        <SideMenu class="w-100 bg-inherit" />
      </Drawer>

      <SideMenu
        class="md:block hidden fixed top-14 left-0 w-1/4 p-4 bg-slate-200"
        style="height: calc(100vh - 3.5rem);"
      />
    </div>

    <div :class="{
      absolute: true,
      'top-14': user.loggedIn,
      'top-0': !user.loggedIn,
      'flex-1': true,
      'container': true,
      'w-100': true,
      'md:right-0': user.loggedIn,
      'md:!w-3/4': user.loggedIn,
      'p-3': true,
      'left-0': !user.loggedIn,
      'right-0': !user.loggedIn,
      'mx-auto': !user.loggedIn,
    }">
      <main>
        <RouterView />
      </main>

      <FooterLinks />

    </div>
  </div>

  <Dialog v-model:visible="showAccountDialog" header="Account" modal :draggable="false" class="w-full mx-4" style="max-width: 24rem;">
    <div class="flex flex-col gap-4">
      <div>
        <div class="text-xs font-semibold uppercase tracking-wide text-slate-400 mb-1">Signed in as</div>
        <div class="text-sm">{{ user.email }}</div>
      </div>
      <Button
        label="Sign Out"
        icon="pi pi-sign-out"
        severity="secondary"
        outlined
        class="border-black"
        @click="signOut"
      />
    </div>
  </Dialog>

  <Toast />
  <ConfirmDialog class="max-w-lg"></ConfirmDialog>
</template>

<style scoped>
main {
  min-height: calc(80vh - 4rem);
}
</style>